import { SubscriptionPlanName } from '@sparemin/api-sdk';
import cn from 'classnames';
import React from 'react';

import { PlanInstanceProps } from 'blocks/Pricing/types';
import { basicFeatureList } from '../features';
import Plan from '../Plan';
import { basicPlanBlock as block } from '../utils';
import BasicPlanCta from './BasicPlanCta';
import BasicPlanHeader from './BasicPlanHeader';

const BasicPlan: React.FC<PlanInstanceProps> = ({
  className,
  cta: ctaOverride,
  onUpgradeClick,
  period,
}) => {
  const isMonthly = period === 'monthly';

  return (
    <Plan className={cn(block(), className)}>
      <BasicPlanHeader
        previousCost={
          isMonthly
            ? {
                monthly: SubscriptionPlanName.BASIC_20250516_MONTHLY,
              }
            : undefined
        }
        period={period}
        isLimitedTime={isMonthly}
      />
      <Plan.Description
        callToAction={
          <BasicPlanCta {...{ period, ctaOverride }} onClick={onUpgradeClick} />
        }
        features={basicFeatureList}
      />
    </Plan>
  );
};

export default BasicPlan;
